const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/asset-groups/$groupId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import type { UpdateAssetGroupRequest } from "@/types/api/asset-group";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/client/asset-groups/$groupId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const assetGroupSchema = z.object({
  groupName: z.string().min(1, "Group Name is required"),
  description: z.string().optional(),
  isActive: z.boolean()
});
type AssetGroupFormValues = z.infer<typeof assetGroupSchema>;